import PharmacyList from "@/components/pharmacies/PharmacyList.vue";

const pharmacyRoutes = [
  { path: "/pharmacies", name: "pharmacies", component: PharmacyList },
];

export default pharmacyRoutes;
